import {FC} from 'react';

import {Stack, TextField, Typography} from '@mui/material';

import {colors} from '../../../../shared/colors';
import {IServiceRequest} from '../../../../shared/types/serviceRequest.types';
import {useRecoilValue} from 'recoil';
import {serviceRequestActiveTabState} from '../../../../store/service-requests/atoms';

interface ISecondImported {
  serviceRequest: IServiceRequest;
}

const labelTypographyStyle = {
  backgroundColor: '#ECF1F4',
  border: `1px solid ${colors['border--white--bg']}`,
  textAlign: 'center',
  p: 0.5,
  width: '250px',
};

const inputStyle = {
  width: '310px',
  '& input': {
    fontSize: '0.875rem',
    textAlign: 'center',
    lineHeight: '1.57',
    p: 0.5,
  },
  '& > div': {
    borderRadius: 0,
    p: 0.5,
  },
  '& .Mui-disabled': {
    '-webkit-text-fill-color': 'rgba(0, 0, 0, 0.87) !important',
  },
};

export const SecondImported: FC<ISecondImported> = ({serviceRequest}) => {
  const activeTab = useRecoilValue(serviceRequestActiveTabState);

  // const info = serviceRequest?.workData ? Object.entries(serviceRequest.workData) : []

  return (
    <Stack
      direction="column"
      spacing={0.5}
      sx={{opacity: activeTab?.editMode ? 0.6 : 1, userSelect: activeTab?.editMode ? 'none' : 'auto'}}
    >
      <Typography component="div" variant="subtitle1">
        Данные об установленном объекте
      </Typography>
      {/* {info.map(item => (
                <Stack key={item[0]} direction="row">
                    <Typography sx={labelTypographyStyle} variant="subtitle2" component="div">
                        {item[1].description}
                    </Typography>
                    <TextField value={item[1].value || '-'} disabled sx={inputStyle}/>
                </Stack>
            ))} */}
      <Stack direction="row">
        <Typography sx={labelTypographyStyle} variant="subtitle2" component="div">
          Показания Т1
        </Typography>
        <TextField value={serviceRequest.workData?.t1Import?.value || '-'} disabled sx={inputStyle} />
      </Stack>
      <Stack direction="row">
        <Typography sx={labelTypographyStyle} variant="subtitle2" component="div">
          Дата Т1
        </Typography>
        <TextField value={serviceRequest.workData?.t1DataImport?.value || '-'} disabled sx={inputStyle} />
      </Stack>
      <Stack direction="row">
        <Typography sx={labelTypographyStyle} variant="subtitle2" component="div">
          Показания Т2
        </Typography>
        <TextField value={serviceRequest.workData?.t2Import?.value || '-'} disabled sx={inputStyle} />
      </Stack>
      <Stack direction="row">
        <Typography sx={labelTypographyStyle} variant="subtitle2" component="div">
          Дата Т2
        </Typography>
        <TextField value={serviceRequest.workData?.t2DataImport?.value || '-'} disabled sx={inputStyle} />
      </Stack>
    </Stack>
  );
};
